var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSystemUiconsWrite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "system-uicons:write"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.14286 15.4998H15M13.2857 6.07124L14.1429 6.92838M14.5714 3.92838C14.7403 4.09721 14.8743 4.29764 14.9657 4.51825C15.0571 4.73886 15.1041 4.97531 15.1041 5.2141C15.1041 5.45289 15.0571 5.68934 14.9657 5.90994C14.8743 6.13055 14.7403 6.33099 14.5714 6.49981L6.42857 14.6427L3 15.4998L3.85714 12.1192L12.0034 3.93181C12.3245 3.60916 12.7552 3.41904 13.2099 3.39919C13.6647 3.37934 14.1103 3.53122 14.4583 3.82467L14.5714 3.92838Z",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemUiconsWrite);
export default __webpack_public_path__ + "static/media/system-uicons_write.7964f30be5a3b96d82babd868d5a0458.svg";
export { ForwardRef as ReactComponent };